import React from 'react';
import Image from 'next/image';
import SectionHeading from '../../Common/SectionHeading';
import Link from 'next/link';

const BenefitsOfFirstMoverSection = ({title=null}) => {
  return (
    <section className="mt-20">
      <section className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto lg:my-8 my-4" style={{ backgroundColor: '#1b5df3' }}>
        <section className="grid grid-cols-12 gap-4">
          <div className="lg:col-span-7 col-span-12  mt-auto mb-auto p-10">
            {(title) &&
              <SectionHeading title={title} customClass="text-left text-white"/>
            }
            <p className="text-white">
              Stay ahead of the competition with our healthcare-focused competitive intelligence tracking. Get in touch for a personalized proposal
            </p>
            <Link href={process.env.APP_URL+"/request-for-proposal"}>
              <button type="submit" style={{ background: '#ffffff', border: '1px solid #1b5df3', padding: '10px 15px', width: 'auto', fontSize: '15px', borderRadius: '0px', color: '#1b5df3' }}>Request for Proposal</button>
            </Link>
          </div>
          <div className="lg:col-span-5 col-span-12 pr-0">
            <div className="ready-img" style={{ marginTop: '-3em' }}>
              <Image 
                priority={false} 
                src={process.env.IMG_CDN+'img/consulting/jpg/ci-tracking/reap-the-benefits-of-being-a-first-mover.png'} 
                style={{ float: 'right' }} 
                alt="Reap the benefits of being a First Mover" 
                className="hidden lg:block" 
                width={2000} 
                height={2000}
              />
            </div>
          </div>
        </section>
      </section>
    </section>
  );
};

export default BenefitsOfFirstMoverSection;